import $ from "jquery";
import { $body } from '../Constants';

/**
 * HtmlElement
 *
 * @class
 */
export default class HtmlElement {
  /**
   * @constructor
   *
   * @param { jQuery } $element
   */
  constructor($element) {
    this._$element = $element;
    this._queuedFunctions = [];
  }

  // Public

  /**
   * Handles ready event
   *
   * @return void
   */
  onReady() {
    if (this._queuedFunctions.length > 0) {
      this._queuedFunctions.forEach((queuedFunction) => {
        queuedFunction();
      });
    }
  }

  /**
   * Queues a function which will be called on the onReady event
   *
   * @param { Function } func
   * @return void
   */
  queueFunction(func) {
    if (typeof func === 'function') {
      this._queuedFunctions.push(func);
    }
  }

  /**
   * Checks if the element exists on the current page
   *
   * @return { boolean }
   */
  exists() {
    return this._$element.length > 0;
  }

  /**
   * Get total $element height
   *
   * @param { boolean } margin whether to include the element margin in the returned height
   * @return { int }
   */
  getHeight(margin = false) {
    return this._$element.outerHeight(margin);
  }

  // Getters

  /**
   * Returns the HTML element
   *
   * @return { jQuery } _$element
   */
  get $element() {
    return this._$element;
  }

  /**
   * Returns all elements with it's instance
   *
   * @param { String } selector
   * @param { HtmlElement } classObject
   * @return { Array } elements
   */
  static _getElements(selector, classObject) {
    let elements = [];

    $body.find(selector).each((i, el) => {
      elements.push(this._getElement($(el), classObject));
    });

    return elements;
  }

  /**
   * Returns a single instance of the given classObject
   *
   * @param { jQuery } $el
   * @param { HtmlElement } classObject
   * @return { HtmlElement }
   */
  static _getElement($el, classObject) {
    return (new classObject($el));
  }
}
